import React from "react";
import "./App.css";
import { ThemeProvider, createTheme, CssBaseline } from "@mui/material";
import { Routes } from "./Routes/index.routes";
import GlobalStyles from "./Styles/global";
import { UsuarioProvider } from "./Hooks/UsuarioHook";
import { UsuarioStorageProvider } from "./Storage/UsuariosStorage";
import { SistemaStorageProvider } from "./Storage/SistemaStorage";
import { EntidadeProvider } from "./Hooks/EntidadeHook";
import { ThemeModeProvider, useThemeMode } from "./Contexts/ThemeModeContext";

function ThemedApp() {
  const { modo } = useThemeMode();

  const theme = React.useMemo(
    () =>
      createTheme({
        palette: {
          mode: modo,
          primary: { main: "#4f8ef7" },
          background:
            modo === "dark"
              ? { default: "#2c2f3a", paper: "#363a47" }
              : { default: "#e8ecf2", paper: "#f2f4f8" },
          divider:
            modo === "dark" ? "rgba(255,255,255,0.08)" : "rgba(0,0,0,0.12)",
        },
        shape: { borderRadius: 10 },
        typography: {
          fontFamily: "'Plus Jakarta Sans', 'Segoe UI', sans-serif",
          h4: { fontWeight: 800, letterSpacing: "-0.5px" },
          h5: { fontWeight: 700, letterSpacing: "-0.4px" },
          h6: { fontWeight: 600 },
          button: { fontWeight: 600 },
        },
        components: {
          MuiButton: {
            styleOverrides: {
              root: { textTransform: "none", borderRadius: 10 },
            },
          },
          MuiPaper: {
            styleOverrides: { root: { backgroundImage: "none" } },
          },
          MuiOutlinedInput: {
            styleOverrides: { root: { borderRadius: 10 } },
          },
        },
      }),
    [modo]
  );

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <GlobalStyles />
      <EntidadeProvider>
        <UsuarioProvider>
          <UsuarioStorageProvider>
            <SistemaStorageProvider>
              <Routes />
            </SistemaStorageProvider>
          </UsuarioStorageProvider>
        </UsuarioProvider>
      </EntidadeProvider>
    </ThemeProvider>
  );
}

function App() {
  return (
    <ThemeModeProvider>
      <ThemedApp />
    </ThemeModeProvider>
  );
}

export default App;
